import { Components, Theme } from '@mui/material/styles';

export const textField = (theme: Theme): Components => {
  const additionalGrey = theme.palette.grey.additionalGrey;
  const additionalGrayWithOpacity = theme.palette.grey?.['200'];
  const mainColor = theme.palette.primary?.main;
  const errorColor = theme.palette.error?.main;
  const placeholderFont = theme.typography.fontFamily;
  const placeholderColor = theme.palette.grey.placeholderGrey;
  const placeholderFontSize = '12px';
  const placeholderFontWeight = 400;
  const iconColor = additionalGrey;

  // в компоненті TextField обов'язково прописати InputLabelProps={{ shrink: true }}

  const commonInputStyles = {
    width: '100%',
    boxSizing: 'border-box',
    height: 48,
    padding: '13px 13px 13px 25px',
    fontSize: '14px',
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '-1px',

    '&.MuiInputBase-inputAdornedStart': {
      paddingLeft: 0,
    },
    '&.MuiInputBase-inputAdornedEnd': {
      paddingRight: 0,
    },
    '&::placeholder': {
      color: `${placeholderColor} !important`,
      fontFamily: placeholderFont,
      fontSize: placeholderFontSize,
      fontWeight: placeholderFontWeight,
      opacity: '1 !important',
      visibility: 'visible !important',
    },
    '&::-webkit-input-placeholder': {
      color: `${placeholderColor} !important`,
      fontFamily: placeholderFont,
      fontSize: placeholderFontSize,
      fontWeight: placeholderFontWeight,
      opacity: '1 !important',
      visibility: 'visible !important',
    },
    '&:-ms-input-placeholder': {
      color: `${placeholderColor} !important`,
      fontFamily: placeholderFont,
      fontSize: placeholderFontSize,
      fontWeight: placeholderFontWeight,
      opacity: '1 !important',
      visibility: 'visible !important',
    },

    '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '&[type="number"]': {
      MozAppearance: 'textfield',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      transform: 'scale(0.5625)',
      transformOrigin: 'top left',
      width: '177.78%',
      height: '53.33px',
      padding: '0 36px',
      letterSpacing: '-0.3px',

      '&.MuiInputBase-inputAdornedStart': {
        paddingLeft: 0,
      },
      '&.MuiInputBase-inputAdornedEnd': {
        paddingRight: 0,
      },

      '&.MuiAutocomplete-input': {
        padding: '0 36px !important',

        '&::placeholder': {
          fontSize: 'inherit !important',
          opacity: '1 !important',
        },
        '&::-webkit-input-placeholder': {
          fontSize: 'inherit !important',
          opacity: '1 !important',
        },
      },

      '&.table-text, &.table-date': {
        padding: '5px',
      },

      '&::placeholder': {
        fontSize: 'inherit !important',
      },
      '&::-webkit-input-placeholder': {
        fontSize: 'inherit !important',
      },
      '&:-ms-input-placeholder': {
        fontSize: 'inherit !important',
      },
    },
  };

  return {
    MuiFormControl: {
      styleOverrides: {
        root: {
          position: 'relative',
          paddingBottom: 14,
          [theme.breakpoints.down('sm')]: {
            paddingBottom: 13,
          },
        },
      },
    },

    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: iconColor,
          '& svg': {
            fontSize: '20px',
          },
        },
        positionStart: {
          marginRight: '8px',
          marginLeft: '12px',
        },
        positionEnd: {
          marginLeft: '8px',
          marginRight: '12px',
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before, &:hover:not(.Mui-disabled):before, &:after': {
            borderBottom: 'none',
          },
        },
        root: {
          width: '100%',
          borderRadius: 4,
          backgroundColor: theme.palette.common.white,
          boxSizing: 'border-box',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden',
          marginTop: 0,
          'label + &': {
            marginTop: 0,
          },
          '&:before': {
            display: 'none',
            borderBottom: 'none !important',
          },
          '&:after': {
            display: 'none',
            borderBottom: 'none !important',
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottom: 'none !important',
          },

          [theme.breakpoints.down('sm')]: {
            height: '30px',
          },

          '&.Mui-disabled': {
            backgroundColor: additionalGrayWithOpacity,
            cursor: 'not-allowed',
          },
          '.Mui-disabled:hover': {
            borderColor: theme.palette.grey[100],
          },
        },
        input: commonInputStyles as any,
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          width: '100%',
          borderRadius: 4,
          backgroundColor: theme.palette.common.white,
          boxSizing: 'border-box',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden',

          [theme.breakpoints.down('sm')]: {
            height: '30px',
          },

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: mainColor,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: mainColor,
            boxShadow: 'none',
          },

          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: errorColor,
          },
          '&.Mui-disabled': {
            backgroundColor: additionalGrayWithOpacity,
            cursor: 'not-allowed',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'inherit',
            },
          },
        },

        notchedOutline: {
          borderColor: additionalGrey,
          borderWidth: 1,
          borderStyle: 'solid',
          boxSizing: 'border-box',
          margin: 0,
          padding: 0,
          top: 0,
          bottom: 0,
          height: '100%',
          '& legend': {
            display: 'none',
            height: 0,
            padding: 0,
            lineHeight: 0,
            overflow: 'hidden',
          },
        },

        input: commonInputStyles as any,

        sizeSmall: {
          input: {
            height: 30,
            padding: '8px 0 8px 18px',
            fontSize: '13px',

            '&.MuiInputBase-inputAdornedStart': {
              paddingLeft: 0,
            },
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          display: 'block',
          position: 'relative',
          transform: 'none',
          paddingBottom: theme.spacing(1),
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 1.5,
          color: theme.palette.text.primary,
          margin: 0,
          '&.Mui-focused': {
            color: theme.palette.text.primary,
          },
          '&.Mui-error': {
            color: errorColor,
          },
          [theme.breakpoints.down('sm')]: {
            paddingBottom: '5px',
            fontSize: '10px',
            letterSpacing: '-0.6px',
          },
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: errorColor,
          fontSize: '10px',
          minHeight: 0,
          maxHeight: 'none',
          position: 'absolute',
          top: 'calc(100% - 16px)',
          left: 0,
          right: 0,
          margin: 0,
          marginTop: '2px',
          lineHeight: '14px',

          [theme.breakpoints.down('sm')]: {
            fontSize: '9px',
            marginTop: '4px',
          },
        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 6,
          minWidth: 'auto',
          width: 'auto',
          height: 'auto',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 6,
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
        sizeSmall: {
          padding: 4,
        },
      },
    },
  } as Components;
};
